// extracted by mini-css-extract-plugin
export var subtitle = "_by-2";
export var title = "_by-0";
export var titleNoWrap = "_by-1";